import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import Container from "../../../../components/container/container";
import MySubscriptions from "../../components/my-subscriptions/my-subscriptions";
import MyCameras from "../../components/my-cameras/my-cameras";
import styles from "./connect.module.scss";
import Event from "../../../../core/consts/analytics-events";
import clsx from "clsx";
import useUserSubscriptions from "../../hooks/use-user-subscriptions";
import { useDI } from "../../../../core/di";
import useAutomaticallyOpenPendingSubscription from "../../hooks/use-automatically-open-pending-subscription";
import EmptyDashCams from "../../components/empty-dash-cams/empty-dash-cams";
import throttle from "lodash.throttle";

function Box(props: any) {
  const { className, children } = props;
  const boxClassName = clsx(styles.BoxWrapper, className);
  return <div className={boxClassName}>{children}</div>;
}

export function Connect() {
  let params = useParams();
  const { subscriptions } = useUserSubscriptions();
  const { analytics } = useDI();

  // Side effect, redirect to pending subscription on open
  useAutomaticallyOpenPendingSubscription(subscriptions);

  const isMainConnectPage = Object.keys(params).length === 0;

  useEffect(() => {
    const trackConnectScroll = throttle(
      function () {
        analytics?.track(Event.ConnectScrolled);
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    );

    if (isMainConnectPage) {
      analytics?.track(Event.ConnectViewed);
      window.addEventListener("scroll", trackConnectScroll);
    }

    return () => {
      window.removeEventListener("scroll", trackConnectScroll);
    };
  }, [isMainConnectPage]);

  if (isMainConnectPage) {
    return (
      <Container fullWidth>
        <div className={styles.ConnectWrapper}>
          {subscriptions?.length === 0 ? (
            <EmptyDashCams />
          ) : (
            <React.Fragment>
              <Box className={styles.SubscriptionBox}>
                <MySubscriptions subscriptions={subscriptions} />
              </Box>
              <Box>
                <MyCameras subscriptions={subscriptions} />
              </Box>
            </React.Fragment>
          )}
        </div>
      </Container>
    );
  }
  return <Outlet />;
}

export default Connect;
